<template>
  <v-container>
    <v-row align="start" justify="center">
      <v-col cols="12" sm="12" md="6" xl="4">
        <v-img src="@/assets/bluetheme/Idea.png"></v-img>
      </v-col>
      <v-col cols="12" sm="12" md="6" xl="4">
        <p class="display-3 text-center">IDEA</p>
        <v-spacer></v-spacer>
        <v-divider />

        <v-card flat>
          <v-card-title class="headline">
            <v-icon large color="primary" class="mr-5">mdi-alarm</v-icon>Idea > Setup > Alert
          </v-card-title>
          <v-card-text>You have a good trading idea? You spent much time to analize and setup your trade? Finally, you missed out the best opportunities to enter the market at the RIGHT time and RIGHT price.</v-card-text>
        </v-card>

        <v-card flat>
          <v-card-title class="headline">
            <v-icon large color="primary" class="mr-5">mdi-bookmark</v-icon>Multi Platforms
          </v-card-title>
          <v-card-text>
            You can use online platform like TradingView or desktop platform
            like MT4, MT5, cTrader, … to create Alerts.
          </v-card-text>
        </v-card>

        <v-data-table :headers="headers" :items="flatforms" hide-default-footer>
          <template v-slot:item.name="{ item }">
            <v-img width="100" :src="flatformPath(item)"></v-img>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: "ChartSetup",
  data() {
    return {
      headers: [
        {
          text: "",
          align: "start",
          value: "name"
        },
        { text: "Webhook", value: "webhook" },
        { text: "Web App", value: "webapp" },
        { text: "Email", value: "email" },
        { text: "Telegram", value: "telegram" }
      ],
      flatforms: [
        {
          name: "TradingView",
          logo: "tradingview.png",
          webhook: "yes",
          webapp: "yes",
          email: "yes",
          telegram: "yes"
        },
        {
          name: "cTrader",
          logo: "ctrader.png",
          webhook: "yes",
          webapp: "yes",
          email: "yes",
          telegram: "yes"
        },
        {
          name: "Metatrader",
          logo: "metatrader.png",
          webhook: "yes",
          webapp: "yes",
          email: "yes",
          telegram: "yes"
        }
      ]
    };
  },
  methods: {
    flatformPath(item) {
      return require("@/assets/platforms/logos/" + item.logo);
    }
  }
};
</script>

<style>
</style>
